// PPE 2.0 (DEV-4849 wave 3): client for the margin maker-checker change-request queue
// (MarginChangeRequestController). Approve executes the guarded activation server-side; requester !=
// approver is enforced there (SOX segregation) regardless of the acting user's claims. Every call skips
// the global forbidden-reload: the GET degrades to an empty queue, and the decision WRITES surface a 403
// (or the self-approval 400) inline via the thunk mutation-error slice.
import { SKIP_FORBIDDEN } from './httpConfig';

export class MarginChangeRequestApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPending() {
    return this.#http.get('/api/margin-change-requests/pending', SKIP_FORBIDDEN);
  }

  // DEV-5472: decided/withdrawn history (newest first), optionally narrowed by state + a requested-at
  // UTC window. Undefined params are dropped so an unfiltered call returns the whole trail.
  async getHistory({ state, from, to } = {}) {
    return this.#http.get('/api/margin-change-requests', {
      ...SKIP_FORBIDDEN,
      params: { state: state ?? undefined, from: from ?? undefined, to: to ?? undefined },
    });
  }

  // DEV-5472: requester-only withdraw of a still-Pending request (server 409s for anyone else). Mirrors
  // approve/reject's body so the caller can attach a reason.
  async withdraw(marginChangeRequestId, note) {
    return this.#http.post(
      `/api/margin-change-requests/${marginChangeRequestId}/withdraw`,
      { note: note ?? null },
      SKIP_FORBIDDEN,
    );
  }

  async approve(marginChangeRequestId, note) {
    return this.#http.post(
      `/api/margin-change-requests/${marginChangeRequestId}/approve`,
      { note: note ?? null },
      SKIP_FORBIDDEN,
    );
  }

  async reject(marginChangeRequestId, note) {
    return this.#http.post(
      `/api/margin-change-requests/${marginChangeRequestId}/reject`,
      { note: note ?? '' },
      SKIP_FORBIDDEN,
    );
  }
}
